import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { monthOptions } from "@/lib/statements";

export default function MonthSelect({ value, onChange, testid, className }) {
  const options = monthOptions(12);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className || "w-44"} data-testid={testid}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`${testid}-${o.value}`}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
